'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './reservation-overview.routes';

export class ReservationOverviewComponent {
  constructor($state, Config, ReservationService, Auth) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Reservation Overview");

    this.config = Config.getModuleConfig(Config.Modules.Reservation).getSettings();

    let nowMillis = (new Date()).getTime();

    this.reservations = [];

    ReservationService.getByUser({user: Auth.getCurrentUserSync()._id}, data => {
      data.forEach(evt => {

        let event = {
          state: evt.state
        };

        if (!evt.event) {
          event.title = this.config[evt.type].name;
          event.start = evt.start;
          event.end = evt.end;

          event.url = "/reservation/" + evt.type + "/list";
        } else {
          event.title = evt.event.title;
          event.start = evt.event.start;
          event.end = evt.event.end;

          event.url = "/event-reservation/" + evt.event._id;
        }

        if (new Date(event.start).getTime() > nowMillis) {
          this.reservations.push(event);
        }

      });
    }, err => {
      console.log('could not retrieve reservations');
    }) ;
  }
}

export default angular.module('conduuApp.reservationOverview', [uiRouter])
  .config(routes)
  .component('reservationOverview', {
    template: require('./reservation-overview.html'),
    controller: ReservationOverviewComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/overview/reservation-overview.component.js